module.exports = __webpack_public_path__ + "static/media/BoxPlotQ3_4.e37158ad.svg";